import "../_scss/app.scss";
import {YouTubeController} from "./class/YouTubeController.js"
import {VideoController} from "./class/VideoController.js"
import { PlayerUIBinder } from './class/PlayerUIBinder.js'

/**
 * 発火層
 */

const mode = 'mp4' // 'youtube' or 'mp4'

if (mode === 'youtube') {
	window.onYouTubeIframeAPIReady = () => {
		const yt = new YouTubeController({
			videoId: '5zZa7rsLbhs',
			visibleId: 'playerVisible',
			hiddenId: 'playerHidden',
			fps: 25
		})
		initPlayer(yt)
	}
} else {
	const videoVisible = document.getElementById('videoVisible')
	const playerVisible = document.getElementById('playerVisible')
	if (playerVisible) playerVisible.style.display = 'none'

	const video = new VideoController({
		src: '/assets/ningen.mp4',
		videoId: '5zZa7rsLbhs',
		visibleId: 'videoVisible',
		fps: 25
	})
	initPlayer(video)
}

function initPlayer(player) {
	player.setMarkers([
		{ time: 2.00, label: "INTRO" },
		{ time: 7.32, label: "A" },
		{ time: 18.00, label: "B" },
		{ time: 29.00, label: "C" },
		{ time: 47.60, label: "D" },
		{ time: 60.00, label: "E" },
		{ time: 71.84, label: "F" },
		{ time: 91.10, label: "END" }
	])
	
	new PlayerUIBinder(player, {
		loop: {
			start: 2.0,
			end: 91.10
		},
		skips: [
			{ from: 76.20, to: 176.32 }
		]
	})
}


